module.exports = __webpack_public_path__ + "img/PCFirstBg.615467e6.jpg";